import { computed, makeAutoObservable } from 'mobx'

import { WorkspacePortalClient } from 'api/clients/WorkspacePortalClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { type RootStore } from 'stores/RootStore'
import { Portal, PortalColumnCreationAttributes } from 'types'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
export class WorkspacePortalStore {
  rootStore: RootStore
  portal?: Portal
  workspaceKey = ''
  isLoading: boolean = false

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this, {
      sections: computed.struct,
    })
  }

  createPortal = async () => {
    // This is a hack right now until we have a proper way to enable portals. This will
    // happen automatically on the BE when the portal setting is enabled
    const res = await WorkspacePortalClient.createPortal(this.workspaceKey, 'portal', {})

    this.setLoading(true)
    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const pageRes = await WorkspacePortalClient.createPortal(this.workspaceKey, 'page')

      if (pageRes.type === SUCCESS_RESPONSE_TYPE) {
        this.portal = pageRes.data.workspace_portal
        this.setLoading(false)
        return
      }
    }
    this.setLoading(false)
    showToastMessage('Something went wrong creating the page, please try again later', 'error')
  }

  addSection = async (columns: PortalColumnCreationAttributes[]) => {
    if (!this.portal) return

    const res = await WorkspacePortalClient.createPortal(this.workspaceKey, 'section', {
      workspace_page_id: this.portal?.pages[0].id,
      section_type: 'banner',
      position: this.portal?.pages[0].sections.length + 1,
      columns_attributes: columns,
    })

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      this.portal = res.data.workspace_portal
    } else {
      showToastMessage('Something went wrong adding a row, please try again later', 'error')
    }
  }

  get sections() {
    // Assume only one page for new portals, pending old portal deprecation
    return this.portal?.pages[0].sections || []
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading
  }

  setWorkspaceKey = (workspaceKey: string) => {
    this.workspaceKey = workspaceKey
    this.load()
  }

  load = async () => {
    if (!this.workspaceKey) return

    this.setLoading(true)

    const res = await WorkspacePortalClient.forceGetPortal(this.workspaceKey)
    if (res.type === SUCCESS_RESPONSE_TYPE && res.data) {
      this.portal = res.data.workspace_portal
    }

    this.setLoading(false)
  }
}
